import { Component, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

import * as bookingAction from './actions/booking.action';
import * as infoAction from './actions/info.action';
import * as headerAction from './actions/header.action';
import { State } from './reducers/index';

@Component({
  selector: 'consentz-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  public permission$: Observable<headerAction.Permissions>;
  public currentBookingOptions: any;

  constructor(
    private store: Store<State>,
  ) {
  let firstLoad = true;
    // set app id
    localStorage.setItem('AppId', window.location.hash.split('/')[1]);
    // widget options && settings requests
    this.store.dispatch({ type: headerAction.OVERLAY_START });
    this.store.dispatch({ type: headerAction.HIDE_HEADER });
    this.store.dispatch({ type: bookingAction.BOOKING_REQUEST });
    this.store.dispatch({
      type: bookingAction.BOOKING_REQUEST,
      payload: {
        requestUrl: '/settings'
      }
    });
    // get data to continue booking
    this.store.dispatch({
      type: infoAction.INFO_UPDATE,
      payload: JSON.parse(localStorage.getItem('data'))
    });
    // subscribtion on header permission and widget options
    this.permission$ = this.store.select<any>('header');
    this.store.select<any>('booking').subscribe((data: bookingAction.Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        localStorage.setItem('currentBookingOptions', JSON.stringify(data));
      }
      this.currentBookingOptions = localStorage.getItem('currentBookingOptions') !== 'null' && JSON.parse(localStorage.getItem('currentBookingOptions'));

      if (firstLoad && this.currentBookingOptions && this.currentBookingOptions.downloadedStyles) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = this.currentBookingOptions.downloadedStyles;
        document.head.appendChild(link);
        firstLoad = false;
      }
    });
  }

  public ngOnInit(): void {}
  // delete user if we go out
  public ngOnDestroy(): void {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserToken');
    localStorage.removeItem('cardToken');
    localStorage.removeItem('currentBookingOptions');
  }

}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/app.component.ts